import kaudiOne from "./shell.mp3";
import bazaarOne from "./bazaar.mp3";
import celebration from "./celebration.mp3";
import collectionAddedToRoomTwo from "./collection_added_to_room2.mp3";
import correct2 from "./correct2.mp3";
import quizStart from "./quizStart.mp3";
import truck from "./truck.mp3";
import walking from "./walking1.mp3";
import click_Sound from "./clickSound.mp3";
import wrongAnswer from "./wrongAnswer.mp3";
import train from "./train1.mp3";
import plane from "./plane1.mp3";
import car from "./car.mp3";
import bus from "./bus.mp3";

export const kaudiOneSound = new Audio(kaudiOne);
export const bazaarOneSound = new Audio(bazaarOne);
export const celebrationSound = new Audio(celebration);
export const collectionAddedToRoomTwoSound = new Audio(
  collectionAddedToRoomTwo
);
export const correctTwoSound = new Audio(correct2);
export const planeSound = new Audio(plane);
export const quizStartSound = new Audio(quizStart);
export const trainSound = new Audio(train);
export const truckSound = new Audio(truck);
export const walkingSound = new Audio(walking);
export const clickSound = new Audio(click_Sound);
export const wrongAnswerSound = new Audio(wrongAnswer);
export const carSound = new Audio(car);
export const busSound = new Audio(bus);
